<template>
  <div class="index">
    <van-sticky :offset-top="0">
      <div style="background: linear-gradient(to right ,rgba(14,122,248) 70%,rgba(55,151,254));">
        <div class="search">
          <div class="logo"><img src="../assets/img/logo.jpg" alt=""></div>
          <div class="searchbox1">
            <van-search v-model="re_value" show-action left-icon placeholder="请输入搜索关键词" @search="onSearch">
              <!--              <template #label>
                <van-loading v-if="isCityLoading" size="20" color="#1989fa"/>
                <div v-else @click="getCity">
                  <span style="color: #55aaff;">{{LocationCity}}</span>
                  <van-icon name="arrow-down" size="13px" style="padding:0 5px;" color="#55aaff"/>
                </div>
              </template>-->
              <template #action>
                <button class="btn" type="button" @click="onSearch">搜索</button>
              </template>
            </van-search>
          </div>
        </div>
        <div class="hd">
          <div class="tags" style="margin-left: 10px;">
            <van-button class="noneborder" :class="selectcaltag == item.goods_name ? 'van-button-active' : ''"
              @click="goGoods(item.goods_id)" plain round size="mini" v-for="item in randProduct"
              :key="item.goods_id">{{
                item.goods_name }}</van-button>
          </div>
        </div>
      </div>
    </van-sticky>
    <div class="leoshop-content" style="padding-bottom:0px">
      <van-swipe class="swipebox" v-if="banner" :autoplay="3000" lazy-render style="height: 180px;">
        <van-swipe-item v-for="(item, index) in banner" :key="index">
          <a :href="item.url"> <img :src="item.image"></a>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="content-index">
      <div class="grid-box grid-box5">
        <div class="grid-item grid-item5 bgcolor" v-for="(item, index) in recommendData" :key="index"
          @click="goPageList(index)">
          <van-icon v-if="item.name.indexOf('门票') != -1" class="van-icon iconfont" name="ziyuan3" class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('酒店') != -1" class="van-icon iconfont" name="jiudian"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('度假') != -1" class="van-icon iconfont" name="lvyou1"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('美食') != -1" class="van-icon iconfont" name="meishika"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('包车') != -1" class="van-icon iconfont" name="yongche"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('拍') != -1" class="van-icon iconfont" name="xiangji"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('直通车') != -1" class="van-icon iconfont" name="zhitongche"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('特产') != -1" class="van-icon iconfont" name="tutechan"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('晚会') != -1" class="van-icon iconfont" name="wutai"
            class-prefix="icon" />
          <van-icon v-else-if="item.name.indexOf('巴士') != -1" class="van-icon iconfont" name="bus"
            class-prefix="icon" />
          <van-icon v-else class="van-icon iconfont" name="weibiaoti1" class-prefix="icon" />
          <p class="name">{{ item.name }}</p>
        </div>
      </div>
      <div class="gg bgColorY" v-if="billboard.length > 0">
        <div class="title">
          <div class="left">
            <span class="bsize">特价榜单</span>
            <span class="desc">尖货精选 宝藏推荐</span>
          </div>
          <div>
            <span style="font-size: 14px;">更多</span>
            <van-icon name="arrow"></van-icon>
          </div>
        </div>
        <div class="grid-box">
          <div class="grid-item grid-item2" v-for="item in billboard" :key="item.id">
            <a class="item" :href="item.url">
              <van-image class="img" fit="cover" :src="item.image"></van-image>
              <div class="ells ttname">{{ item.title }}</div>
            </a>
          </div>
        </div>
      </div>
      <div class="gg jxbg" v-if="destination.length > 0">
        <div class="title">
          <div class="left colorb">
            <div class="bsize">精选目的地</div>
            <div class="desc">尖货精选 宝藏推荐</div>
          </div>
          <div class="rigth">
            <p class="bgbtn">
              目的地大全
              <van-icon name="play" />
            </p>
          </div>
        </div>
        <van-swipe class="grid-box" :loop="false" :show-indicators="false" :width="120" :height="110">
          <van-swipe-item class="grid-item" style="padding-right: 10px;" v-for="(item, index) in destination"
            :key="index" @click="goPlnew(item)">
            <van-image class="img" fit="cover" :src="item.image">
              <div class="tname">
                <div class="jqname ells">{{ item.name }}</div>
              </div>
            </van-image>
          </van-swipe-item>
        </van-swipe>
        <!--<div class="grid-box">
					 <div class="grid-item grid-item3" v-for="item in destination" :key="item.id">
						<a class="item" :href="item.url">
							<van-image class="img" fit="cover" :src="item.image">
								<div class="tname">
									<div class="jqname ells">
										{{item.title}}
									</div>
								</div>
							</van-image>
						</a>
					</div>
        </div>-->
        <img class="bgimg" src="../assets/img/bg1.png" alt>
      </div>
      <div class="hd box" v-if="nav.length > 0">
        <div class="tags">
          <div class="tagimg" v-for="(item, index) in nav" :key="index">
            <a :href="item.url">
              <van-image class="img" fit="cover" :src="item.image"></van-image>
            </a>
          </div>
        </div>
      </div>
      <div class="listdata">
        <div class="listdata-title" :style="'background-color:' + gcfg.BackgroundColor">
          <span :style="'color:' + gcfg.TopTextColor">热销推荐</span>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
          <div class="items">
            <div class="item" v-for="item in productList" :key="item.goods_id" @click="goGoods(item.goods_id)">
              <van-image fit="cover" class="img" :src="item.image">
                <div class="ttip" v-if="item.category_name != null">
                  <span>{{ item.category_name }}</span>
                </div>
              </van-image>
              <div class="textconten">
                <div class="ttname">{{ item.goods_name }}</div>
                <div class="tips"></div>
                <div class="pitem">
                  <div class="price">
                    <span>
                      ￥
                      <span class="pricenum">{{ item.goods_price }}</span>
                    </span>起
                  </div>
                  <van-icon name="weapp-nav" />
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <Copyright style="margin-top:4em;"></Copyright>
      </div>
    </div>
    <cube-view></cube-view>
    <float-icons padding="10 10 60 10" class="icons-warp">
      <div class="float-icon-item" @click="goMy">
        <van-icon size="20" name="manager-o" />
        <span>我的</span>
      </div>
      <div class="float-icon-item" @click="goOder">
        <van-icon size="20" name="orders-o" />
        <span>订单</span>
      </div>
    </float-icons>
    <van-popup v-for="(item, i) in ggShow1" :key="'popup' + i" :overlay="i == 0" v-model="item.show" class="gg-popup"
      @close="ggClose1(i)" :close-on-click-overlay="false" style="width: 70%;">
      <div class="cc-qq">
        <div class="title" v-if="item.title">
          <p>{{ item.title }}</p>
        </div>
        <div class="gg-content" v-if="item.content">
          <div v-html="item.content"></div>
        </div>
        <div class="notice-footer">
          <van-checkbox v-model="item.checked" class="no-popup" shape="square" @change="noticeOnChange(item)"
            icon-size="14px">
            30日内不再弹出
          </van-checkbox>
        </div>
      </div>
      <div class="qq-clode">
        <van-icon name="close" @click="ggClose1(i)" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast } from "vant";
import CubeView from "@/components/TP/cube-view";
import BottomTabbar from "@/components/TP/BottomTabbar";
import Copyright from "@/components/TP/Copyright";
import FloatIcons from "@/components/TP/s-icons";
import * as util from "@/utils/network";
import getCurrentCityName from "@/utils/getUserLocation";

import vueWaterfallEasy from "vue-waterfall-easy";

export default {
  name: "indx",
  components: {
    CubeView,
    BottomTabbar,
    Copyright,
    vueWaterfallEasy,
    FloatIcons
  },
  data() {
    return {
      loading: false,
      finished: false,
      isNoData: false,
      pageIndex: 1,
      pageTotal: 0,
      re_value: "",
      selectcaltag: "",
      sltag: "",
      gcfg: [],
      productList: [],
      billboard: [],
      destination: [],
      nav: [],
      randProduct: [],
      recommendData: [],
      LocationCity: "获取中", //给渲染层定义一个初始值
      isCityLoading: false,
      show: true,
      ggShow1: [],
      banner: [],
    };
  },
  methods: {
    //去查询界面
    goPlnew(item) {
      this.$router.push({
        path: "/plnew",
        query: {
          scenic_spots_id: item.id,
          scenic_spots_name: item.name
        }
      });
    },
    ggClose1(i) {
      this.ggShow1[i].show = false;
    },
    goMy() {
      this.$router.push({
        name: "My"
      });
    },
    goOder() {
      util.redirect("disorder?showType=0");
    },
    //获取城市
    getCity() {
      let that = this;
      that.isCityLoading = true;
      getCurrentCityName().then(city => {
        that.isCityLoading = false;
        that.LocationCity = city;
      });
    },
    goPageList(v) {
      this.$router.push({
        name: "PageList",
        params: {
          active: v
        }
      });
    },
    onSearch() {
      //跳转
      let that = this;
      this.$router.push({
        path: "/relist",
        query: {
          name: that.re_value
        }
      });
    },
    onTagCalBtn(v) {
      this.selectcaltag = v;
    },
    onTagBtn(v) {
      this.sltag = v;
    },
    // 去详情页
    goGoods(id) {
      localStorage.setItem("goodsId", id);
      var url = window.location.href + "goods?id=" + id;
      if (url.indexOf("localhost:8081") < 0) {
        url = window.location.href + "jonlv/v2/goods?id=" + id;
      }
      util.setCookie("CALLBACK_URL", url);

      this.$router.push({
        path: "goods",
        query: {
          id: id
        }
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      let that = this;
      // 异步更新数据
      that.pageIndex++;
      setTimeout(() => {
        that.getProductData();
      }, 1000);
    },
    // 获取banner数据
    getData() {
      let that = this;
      var url = "/addons/litestore/api.index/index";
      //这里直接调用网络接口
      util.post(
        url,
        {
          is_type: that.$route.query.is_type
        },
        function (result) {
          that.billboard = result.data.billboard;
          that.banner = result.data.home;
          that.nav = result.data.nav;
          that.randProduct = result.data.randProduct;
        }
      );
    },
    getProductData() {
      let that = this;
      var url = "/addons/litestore/api.index/productList";
      let param = {
        page: that.pageIndex
      };
      //这里直接调用网络接口
      util.post(url, param, function (result) {
        let data = result.data;
        that.loading = false;
        //这里对状态 进行分类
        that.pageTotal = data.total;
        if (that.pageTotal < 1) {
          that.isNoData = true;
          return;
        }
        if (data.list == null || data.list.length === 0) {
          // 加载结束
          that.finished = true;
          return;
        }
        // 将新数据与老数据进行合并
        that.productList = that.productList.concat(data.list);
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.productList.length >= that.pageTotal) {
          that.finished = true;
        }
      });
    },
    getSidebarData() {
      var url = "/addons/litestore/api.category/Showlist";
      let that = this;

      //这里直接调用网络接口
      util.get(url, {}, function (result) {
        that.recommendData = result["data"]["categorydata"];
      });
    },
    async getGg() {
      var url = "/addons/litestore/api.index/notice";
      let that = this;
      that.ggShow1 = [];
      //这里直接调用网络接口
      await util.get(
        url,
        {
          type: 1,
          place: 103
        },
        //30 * 24 * 60 * 60 * 1000;
        function (res) {
          res.data.forEach(item => {
            that.ggShow1.push({
              title: item.title,
              content: item.content,
              id: item.id,
              show: true
            });
          });
        }
      );
    },
    // 创建一个函数来处理逻辑
    processArrays(aArray, bArray) {
      const currentTime = Date.now();
      const thirtyDays = 30 * 24 * 60 * 60 * 1000;

      const bMap = new Map();

      bArray.forEach(bItem => {
        const timeDiff = currentTime - bItem.time;

        if (timeDiff > thirtyDays) {
          bItem.time = Date.now();
          bItem.checked = false;
        }

        if (timeDiff <= thirtyDays) {
          bMap.set(bItem.id, bItem.checked);
        }
      });

      const processedA = aArray.map(aItem => {
        const isChecked = bMap.get(aItem.id) || false;

        return {
          ...aItem,
          checked: isChecked,
          show: isChecked ? false : true,
          isValid: bMap.has(aItem.id)
        };
      });

      return {
        a: processedA,
        b: bArray
      };
    },

    getSwiperData() {
      var url = "/addons/litestore/api.goodsscenic/selectpage";
      let that = this;

      //这里直接调用网络接口
      util.get(url, {}, function (result) {
        that.destination = result.list;
      });
    },
    noticeOnChange(item) {
      const url = "/addons/litestore/api.index/closeNotice";
      util.post(url, { id: item.id });
    },
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.getGg();
    this.getSwiperData();
    //this.getCity();
    this.getData();
    this.getSidebarData();
    this.getProductData();
  },
  watch: {
    "$store.state.gcfg": function () {
      this.gcfg = this.$store.getters.getGcfg;
    }
  }
};
</script>

<style lang="less">
@import url("../assets/css/listboxless.less");

.gg-popup {
  background: transparent;

  .cc-qq {
    border-radius: 10px;
    background-color: #fff;

    .title {
      padding: 8px 10px;
      font-size: 14px;
      background-color: #ff8a3a;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      color: #fff;

      p {
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .van-row {
      padding: 0 15px;
      margin-top: 10px;

      .van-col--12 {
        .van-image {
          height: 156px;
        }
      }

      .van-col--8 {
        .van-image {
          height: 104px;
        }
      }
    }

    .imgs {
      display: flex;

      // height: 156px;
      .van-image+.van-image {
        margin-left: 10px;
      }
    }

    .gg-content {
      //max-height: 480px;
      height: 400px;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: scroll;
      font-size: 13px;
      line-height: 22px;
    }
  }

  .qq-clode {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;

    .van-icon {
      color: #fff;
      font-size: 28px;
    }
  }
}

.ggs1 {
  width: 60% !important;
}

.ggs2 {
  width: 55% !important;
}

.ggs3 {
  width: 50% !important;
}

.icons-warp {
  border-radius: 20px;
  // background: linear-gradient(to right, rgba(76, 168, 255) 60%, rgba(60, 192, 255)) !important;
  background: linear-gradient(#ff8a3a, #fea444) !important;

  .float-icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 50px;
    height: 50px;
    color: #fff;

    img {
      width: 25px;
      height: 25px;
      margin-bottom: 3px;
    }

    span {
      font-size: 9px;
      // color: #666666;
    }
  }
}

.index {
  background-color: #f7f7f7;

  .van-image {
    width: 100%;
    height: 100%;
  }

  .bgColorY {
    background: linear-gradient(to right, #fff, #ffeee4);

    .title {
      color: #ff5b00;
    }
  }

  .jxbg {
    position: relative;
    z-index: 1;

    .bgimg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      opacity: 0.5;
      z-index: -1;
      border-radius: 10px;
    }
  }

  .van-image {
    position: relative;
    box-sizing: border-box;

    .ttip {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #d38958;
      height: 25px;
      line-height: 25px;
      border-top-left-radius: 10px;
      border-bottom-right-radius: 10px;
      padding: 0 6px;

      span {
        color: #fff;
        font-size: 13px;
      }
    }

    .tname {
      width: 90%;
      position: absolute;
      bottom: 5px;
      left: 0;
      margin-left: 10px;
      margin-right: 5px;
      color: #fff;

      span {
        font-size: 14px;
      }

      .jqname {
        font-size: 14px;
        padding-bottom: 5px;
      }

      .jqdesc {
        padding: 3px 6px;
        font-size: 13px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 3px;
        color: #4d4d4d;
      }

      .ywdesc {
        padding-top: 5px;
        font-size: 13px;
      }
    }
  }

  .listdata {
    .items {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .item {
        margin-top: 10px;
        min-width: 0;
        width: 48%;
        border-radius: 10px;
        padding-bottom: 10px;
        background-color: #fff;

        .img {
          height: 180px;

          img {
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
          }

          .ttip {
            background: rgba(8, 8, 8, 0.2);
            color: #fff;
          }
        }

        .textconten {
          padding: 0 8px;
        }

        .ttname {
          white-space: nowrap;
          overflow: hidden;
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          text-align: left;

          .tip {
            background-color: #ff0000;
            padding: 2px 5px;
            font-size: 12px;
            color: #fff;
            border-radius: 5px;
            font-weight: 400;
          }
        }

        .tips {
          margin: 4px 0;

          span {
            padding: 2px 5px;
            font-size: 12px;
            background-color: #ffe7c0;
            color: #ff7e3e;
            border-radius: 5px;
          }
        }

        .pitem {
          padding-top: 5px;
          display: flex;
          justify-content: space-between;
          color: #737373;

          .price {
            font-size: 14px;

            span {
              color: #ff0000;

              .pricenum {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }

  .gg {
    margin-top: 10px;
    padding: 10px;
    border-radius: 15px;
    box-shadow: 1px 0 1px 0 #f8f8f8;

    .img.van-image {
      width: 100%;

      img {
        border-radius: 10px;
      }
    }

    .img.van-image {
      width: 100%;

      img {
        border-radius: 10px;
      }
    }

    .title {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 5px;

      .left {
        color: #ff5b00;
      }

      .rigth {
        display: flex;

        .bgbtn {
          padding: 3px 6px;
          font-size: 14px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 15px;
        }
      }

      .bsize {
        font-size: 20px;
        padding-right: 15px;
        font-weight: 600;
      }

      .colorb {
        color: #435084;
      }

      .desc {
        padding-top: 2px;
        font-size: 15px;
      }
    }

    .item {
      width: 100%;

      .ttname {
        padding: 5px;
        font-size: 15px;
      }

      .pricetip {
        padding: 0 5px;
        display: flex;

        .p {
          color: #ff0000;
          font-size: 13px;

          .btext {
            font-size: 18px;
          }
        }

        .bgred {
          margin-left: 10px;
          background-color: #ff0000;
          border-radius: 10px;

          span {
            padding: 0 10px;
            font-size: 12px;
            color: #fff;
          }
        }
      }
    }
  }

  .grid-box {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 10px;

    .grid-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;
    }

    .grid-item2 {
      min-width: 0;
      flex-basis: 48.5%;

      .img {
        height: 110px;
      }
    }

    .grid-item3 {
      min-width: 0;
      flex-basis: 32.5%;

      .img {
        height: 138px;
      }
    }

    .grid-item5 {
      min-width: 0;
      flex-basis: 19.5%;

      .van-icon {
        font-size: 32px;
        padding-top: 10px;
      }

      .name {
        padding-bottom: 10px;
      }
    }

    .grid-item5:first-child {
      border-top-left-radius: 15px;
    }

    .grid-item5:last-child {
      border-bottom-right-radius: 15px;
    }

    .grid-item5:nth-child(5) {
      border-top-right-radius: 15px;
    }

    .grid-item5:nth-child(6) {
      border-bottom-left-radius: 15px;
    }

    .bgcolor {
      color: #fff;

      .name {
        margin-top: 5px;
        font-size: 14px;
        text-align: center;
      }
    }

    .bgcolor:nth-child(n + 6) {
      color: #000;
    }

    .bgcolor:first-child {
      background: linear-gradient(#f95f55, #fa8051);
    }

    .bgcolor:nth-child(2) {
      background: linear-gradient(#3e87fa, #4daafa);
    }

    .bgcolor:nth-child(3) {
      background: linear-gradient(#6084ff, #649eff);
    }

    .bgcolor:nth-child(4) {
      background: linear-gradient(#20bcaf, #1accbe);
    }

    .bgcolor:nth-child(5) {
      background: linear-gradient(#ff8a3a, #fea444);
    }

    .bgcolor:nth-child(6) {
      background-color: #fef4f2;

      .van-icon {
        color: #fd754d;
      }
    }

    .bgcolor:nth-child(7) {
      background-color: #eff8ff;

      .van-icon {
        color: #4599fc;
      }
    }

    .bgcolor:nth-child(8) {
      background-color: #f1f3ff;

      .van-icon {
        color: #7e84fe;
      }
    }

    .bgcolor:nth-child(9) {
      background-color: #ecfbf8;

      .van-icon {
        color: #50d2b6;
      }
    }

    .bgcolor:nth-child(10) {
      background-color: #fff9f1;

      .van-icon {
        color: #fd802c;
      }
    }
  }

  .grid-box5 {
    justify-content: space-around;
  }

  .grid-box5 {
    .grid-item5+.grid-item5 {
      // margin-left: 5px;
    }
  }

  .content-index {
    margin: 0 10px;
  }

  .search {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      width: 113px;
      flex-shrink: 0;

      /* 阻止 .logo 元素在 flex 布局中缩小 */
      img {
        width: 100%;
        position: relative;
        top: 2px;
      }
    }
  }

  .searchbox1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 20px;
    // padding-left: 20px;
    // padding-right: 2px;
    height: 38px;
    font-size: 14px;
    margin-left: 10px;

    .van-search {
      width: 100%;
      height: 100%;
      border-radius: 20px;

      .van-search__content {
        padding-left: 0;
        border-radius: 10px;
      }

      .van-search__action {
        padding-left: 8px;
        padding-right: 2px;
      }
    }

    .btn {
      box-sizing: border-box;
      margin-left: 15px;
      width: 50px;
      height: 35px;
      border: none;
      background: linear-gradient(to right,
          rgba(76, 168, 255) 60%,
          rgba(60, 192, 255));
      color: #fff;
      font-size: 13px;
      border-radius: 20px;
    }
  }

  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    border-radius: 20px;
    padding-left: 20px;
    padding-right: 2px;
    height: 38px;
    font-size: 14px;

    .searchinput {
      flex: 1;
      border: none;
    }

    .van-cell {
      padding: 0 !important;
    }

    .btn {
      box-sizing: border-box;
      margin-left: 15px;
      width: 50px;
      height: 35px;
      border: none;
      background: linear-gradient(to right,
          rgba(76, 168, 255) 60%,
          rgba(60, 192, 255));
      color: #fff;
      font-size: 13px;
      border-radius: 20px;
    }
  }

  .hd {
    width: 100%;
    overflow: scroll;
    padding-bottom: 10px;
    box-sizing: border-box;

    .tags {
      // margin: 5px 10px;
      box-sizing: border-box;
      display: flex;

      .tagimg {
        flex-shrink: 0;
        width: 33%;
        height: 60px;
        margin-right: 8px;
      }

      .van-button {
        color: #fff;
        flex-shrink: 0;
        margin-right: 8px;
        background: rgba(241, 241, 241, 0.2);
      }

      .van-button.noneborder {
        border: none;
      }

      .van-button-active {
        background-color: #fff;
        border: 1px solid rgb(14, 122, 248);
        color: rgb(14, 122, 248);
      }
    }

    .menus {
      padding: 0 15px;
      display: flex;
      justify-content: flex-end;

      .m-bub {
        padding: 0 8px;
        background: transparent;
      }
    }
  }

  .hd.box {
    .van-button {
      color: #000000;
      height: 60px;
      width: 120px;
      border-radius: 5px;

      .sm {
        padding-top: 3px;
        font-size: 13px;
        color: #737373;
      }
    }

    .van-button-active {
      border: #fedc00;
      background-color: #fedc00;
    }
  }
}

.notice-footer {
  padding: 10px 0 20px;
  display: flex;
  justify-content: center;

  .ok {
    background-color: #6D189E;
    color: #fff;
    font-size: 12px;
    display: flex;
    align-content: center;
    justify-content: center;
    padding: 8px 20px;
    margin: 0 15px;
    border-radius: 4px;
  }

}
</style>
